export default "__VITE_PUBLIC_ASSET__e8739dec__"